import { store } from "../app/store";
import type { IHotelOccupancyData } from "../features/hotel/hotelInterface";

export const occupancyPersonCount = (
  occupancyData: IHotelOccupancyData[] | undefined,
) =>
  (occupancyData ?? []).reduce((sum, item) => sum + (item.PersonCount ?? 0), 0);

export const resolveRoomOccupancy = (
  roomCategoryId: string,
  adultCount: number,
  childCount = 0,
) => {
  const { hotel } = store.getState();
  const category = hotel.RoomCategoryAvailabilities.find(
    (item) => item.RoomCategoryId === roomCategoryId,
  );
  const occupancies = category?.RoomOccupancyAvailabilities ?? [];
  if (!occupancies.length) return undefined;

  const exact = occupancies.find(
    (occupancy) =>
      occupancy.AdultCount === adultCount && occupancy.ChildCount === childCount,
  );
  if (exact) return exact;

  const byPersons = occupancies.find(
    (occupancy) =>
      occupancyPersonCount(occupancy.OccupancyData) === adultCount + childCount,
  );
  if (byPersons) return byPersons;

  return occupancies[0];
};

export const getOccupancyData = (
  roomCategoryId: string,
  adultCount: number,
  childCount = 0,
): IHotelOccupancyData[] | undefined => {
  const occupancy = resolveRoomOccupancy(
    roomCategoryId,
    adultCount,
    childCount,
  );
  if (occupancy?.OccupancyData?.length) return occupancy.OccupancyData;

  const { hotel } = store.getState();
  const fallbackAgeCategoryId = hotel.RoomCategoryAvailabilities.flatMap(
    (category) => category.RoomOccupancyAvailabilities ?? [],
  )
    .flatMap((item) => item.OccupancyData ?? [])
    .find((item) => item.AgeCategoryId)?.AgeCategoryId;

  if (!fallbackAgeCategoryId) return occupancy?.OccupancyData;

  return [
    {
      AgeCategoryId: fallbackAgeCategoryId,
      PersonCount: adultCount + childCount,
    },
  ];
};
